import React from 'react';
import { X, AlertTriangle, MapPin } from 'lucide-react';

const HealthZoneDeleteModal = ({ healthZone, isOpen, onClose, onConfirm }) => {
  if (!isOpen || !healthZone) return null;

  const handleConfirm = () => {
    onConfirm(healthZone.id);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold text-gray-900">Supprimer la Zone de Santé</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="flex items-start space-x-3 mb-6">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <AlertTriangle className="h-6 w-6 text-red-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Êtes-vous sûr de vouloir supprimer cette zone de santé ?
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Cette action est irréversible. Toutes les données associées à cette zone de santé seront définitivement supprimées.
              </p>
              
              <div className="bg-gray-50 rounded-lg p-4 mb-4">
                <div className="flex items-center text-sm text-gray-600 mb-2">
                  <MapPin className="h-4 w-4 mr-2" />
                  <span className="font-medium">{healthZone.name}</span>
                </div>
                <div className="text-sm text-gray-500">
                  <p>Code: {healthZone.code}</p>
                  <p>Province: {healthZone.province}</p>
                  <p>Territoire: {healthZone.territory}</p>
                  <p>Chef-lieu: {healthZone.chiefTown}</p>
                </div>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                <div className="flex">
                  <AlertTriangle className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" />
                  <div className="text-sm text-yellow-800">
                    <p className="font-medium">Attention !</p>
                    <p>Cette action supprimera définitivement :</p>
                    <ul className="list-disc list-inside mt-1 space-y-1">
                      <li>Les informations de la zone de santé</li>
                      <li>Les statistiques associées</li>
                      <li>L'historique des évaluations</li>
                      <li>Toutes les données liées</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
            >
              Annuler
            </button>
            <button
              onClick={handleConfirm}
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
            >
              Supprimer définitivement
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthZoneDeleteModal;
